import { isDevMode } from '@angular/core';
import {
    MsalGuardConfiguration,
    MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
    BrowserCacheLocation,
    InteractionType,
    IPublicClientApplication,
    LogLevel,
    PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../environments/environment';

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: environment.authConfig.clientId,
            authority: environment.authConfig.authority,
            redirectUri: '/auth',
            postLogoutRedirectUri: '/auth',
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
        system: {
            loggerOptions: {
                loggerCallback: (_level, message) => {
                    if (isDevMode()) console.log(message);
                },
                logLevel: LogLevel.Warning,
                piiLoggingEnabled: false,
            },
        },
    });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string> | null>();
    const apiBase = environment.authConfig.apiConfig.uri;

    // Setup unprotected routes / endpoints
    environment.authConfig.apiConfig.unprotected.forEach((route) => {
        protectedResourceMap.set(apiBase + route, null);
    });

    protectedResourceMap.set(apiBase, environment.authConfig.apiConfig.scopes);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [...environment.authConfig.apiConfig.scopes],
        },
    };
}
